import { render } from "./testimonialOne.vue?vue&type=template&id=5db90c22"
import script from "./testimonialOne.vue?vue&type=script&lang=js"
export * from "./testimonialOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__